export default __webpack_public_path__ + "static/media/xtal.e8daa3e1.webp";